import { Link } from "react-router-dom";
import "./HerlevSeo.css";
import Seo from "../../../Seo/Seo";
import {
    webPageSchema,
    serviceSchema,
} from "../../../Seo/jsonld";
import { getRouteSeo } from "../../../Seo/routeSeo";

const GladsaxeSkolemad = () => {
    const PATH = '/skolemad-gladsaxe'

    return (
        <>
            <Seo
                path={PATH}
                jsonLd={[
                    webPageSchema({
                        title: getRouteSeo(PATH)?.title,
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                    }),
                    serviceSchema({
                        name: "Skolemad og madordninger i Gladsaxe",
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                        areaServed: "Gladsaxe",
                    }),
                ]}
            />
            <main className="herlev-page remove-space">
                <section className="herlev-hero">
                    <div className="herlev-hero-shape herlev-hero-shape-one" />
                    <div className="herlev-hero-shape herlev-hero-shape-two" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="herlev-hero-copy wow fadeInUp">
                                    <span className="herlev-kicker">Skolemad og Madordninger i Gladsaxe</span>
                                    <h1>Madordninger i Gladsaxe – Fra Skoler til Kontorer, Vi Løser Forplejningen</h1>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p className="herlev-lead">
                                        Hverdagen i Gladsaxe er travl. Forældre skal passe børnene, få dem til skole og derefter videre på arbejde. Virksomheder skal tage sig af deres medarbejdere. Skoler skal nå at administrere undervisning. Institutioner skal sikre ordentlig velfærd for deres brugere.
                                    </p>
                                    <p className="herlev-lead">
                                        Onlineskolemad gør forplejningen mindre kompliceret. Vi leverer skolemad direkte til dine børns skole, frokost til dit kontor, og madordninger til institutioner – uden at du skal bruge timer på planlægning og bestilling.
                                    </p>
                                    <p className="herlev-lead">
                                        For familie, virksomhed eller institution i Gladsaxe: Vi tager os af maden, så du kan fokusere på det vigtigste.
                                    </p>
                                    <div className="herlev-actions">
                                        <Link className="herlev-text-link" to="/contact">Kom i gang med en uforpligtende samtale <i className="fas fa-arrow-right" /></Link>
                                    </div>
                                    <div className="herlev-trust-row">
                                        <span><i className="fas fa-check-circle" /> Egne chauffører</span>
                                        <span><i className="fas fa-check-circle" /> Online bestilling</span>
                                        <span><i className="fas fa-check-circle" /> Halal</span>
                                    </div>
                                    <div className="flex-group play-app row">
                                        <div className="col-md-6 ">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/apple-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Download i</span>
                                                    <p>Appstore</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-ios.png" />
                                        </div>
                                        <div className="col-md-6 mt-md-0 mt-4 mb-md-0 mb-5">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/palystore-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Hent den i</span>
                                                    <p>Google Play</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-android.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="herlev-hero-image wow fadeInRight">
                                    <img src="/assets/img/childrens-2.png" alt="Børn, der nyder skolemad" />
                                    <div className="herlev-hero-note"><strong>2730</strong><span>Ballerup</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-intro sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="herlev-photo-frame wow fadeInLeft">
                                    <img src="/assets/img/food-1.png" alt="Frisk skolemad fra Onlineskolemad" />
                                    <span className="herlev-photo-stamp"><i className="fas fa-heart" /> Gør frokosten lettere</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="herlev-copy-block wow fadeInUp">
                                    <span className="herlev-eyebrow">En enklere skoledag</span>
                                    <h2>Hvorfor Madordning Gør Hverdagen Lettere i Gladsaxe</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p>
                                        Gladsaxe er hjem for tusinder af mennesker, der skal balancere arbejde, familie og daglige gøremål. I denne travle hverdag er en pålidelig madordning ikke blot en luksus – den er praktisk nødvendighed.
                                        <br />
                                        En ordnet madordning betyder:
                                    </p>
                                    <ul className="herlev-check-list">
                                        <li>Mindre stress for forældre, der ikke skal planlægge elleveers madpakker hver morgen</li>
                                        <li>Bedre ernæring for børn, da professionelt tilberedt mad sikrer variation og kvalitet</li>
                                        <li>Færre administrative opgaver for skoler, som kan fokusere på undervisning</li>
                                        <li>Mere produktiv arbejdsdag for medarbejdere, der får ordentlig frokost på arbejdet</li>
                                        <li>Lettere drift for institutioner, der skal nå at servicere deres brugere</li>
                                    </ul>
                                    <p>
                                        Gladsaxe er fyldt med betonerede mennesker – mange pendler dagligt til jobbet, passer børn og prøver at holde styr på hverdagens praktikaliteter. Her er det værdifuldt at have nogen, der kan garantere, at maden blot er der, når man har brug for den.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-pd bg-gray position-relative">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 mmb-20">
                                <div>
                                    <div className="title-1 wow fadeInUp" data-wow-delay="0.1s">
                                        <h2>
                                            Gladsaxe – En Kommune med Voksende Behov for Lokal Forplejning
                                        </h2>
                                        <div className="herlev-rule"><span /><span /></div>
                                        <p>
                                            Gladsaxe har undergået betydelig udvikling gennem de seneste år. Kommune er ikke blot et bo-område – det er også en arbejdsplads for tusinder og hjemsted for mange virksomheder.
                                        </p>
                                        <p>
                                            <strong> Skolestruktur og Familieliv </strong> Gladsaxe Kommune har adskillige grundskoler, ungdomsuddannelser og specialiserede læringssteder. Området er karakteriseret ved at være familievenligt, med mange børnefamilier, der søger pålidelige løsninger til skolemad og frokost. Forældrene i Gladsaxe arbejder ofte længere væk og har behov for, at skolemaden er sikret, så de ikke skal tilberede spisekurve hver dag.
                                        </p>
                                        <p>
                                            <strong> Virksomheds- og Arbejdspladskultur </strong> Gladsaxe har udviklet sig til at være et attraktivt sted for virksomheder. Fra mindre kontorer til større erhvervscentre finder man arbejdspladser af varierende størrelse. Arbejdsgivere i Gladsaxe ønsker at tilbyde deres medarbejdere gode arbejdsvilkår – og en daglig frokostordning er en vigtig del heraf. Medarbejdere, der får mulighed for at holde en ordentlig pause og spise kvalitets mad, er mere tilfredse og produktive.
                                        </p>
                                        <p>
                                            <strong>Institutionelle Behov </strong> Børnehaver, dagcentre, ældrecentre og andre institutioner i Gladsaxe skal dagligt løse forplejningsopgaven for deres brugere. En pålidelig madleverandør frigør administrativ ressourcer og sikrer, at alle får den ernæring, de har brug for.

                                        </p>
                                        <p>
                                            <strong>Pendlerkommunen og Tiden </strong> Mange beboere i Gladsaxe pendler til København eller andre dele af storkøbenhavn-området. Dette betyder, at tiden hjemme skal bruges klogt. Når maden leveres til skolen eller kontoret, spares der værdifulde timer til familieliv og personlige gøremål.
                                            Gladsaxe er derfor ikke bare en kommune, hvor man bor – det er en kommune, hvor både familier og virksomheder søger praktiske løsninger, der simplificerer hverdagen.

                                        </p>
                                        <p>
                                            <strong>Onlineskolemad forstår</strong>, at Ballerup er mere end bare en by – det er et sted med mangfoldige institutionelle behov og familier, der søger kvalitet, pålidelighed og fleksibilitet.
                                        </p>
                                        <div className="flex-group play-app row">
                                            <div className="col-md-6 mt-md-0 mt-4 mb-md-0 mb-5">
                                                <Link className="btn btn-dark google_ply mb-3" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                                                    <span className="play_img">
                                                        <img src="/assets/img/apple-icon.svg" alt="not found" />
                                                    </span>
                                                    <div className="download-cont">
                                                        <span>Download i</span>
                                                        <p>Appstore</p>
                                                    </div>
                                                </Link>
                                                <img className="qr-img" src="/assets/img/qr-ios.png" />
                                            </div>
                                            <div className="col-md-6">
                                                <Link className="btn btn-dark google_ply mb-3" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                                                    <span className="play_img">
                                                        <img src="/assets/img/palystore-icon.svg" alt="not found" />
                                                    </span>
                                                    <div className="download-cont">
                                                        <span>Hent den i</span>
                                                        <p>Google Play</p>
                                                    </div>
                                                </Link>
                                                <img className="qr-img" src="/assets/img/qr-android.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="img-style-3 pl-2per img-res-md wow fadeInRight">
                                    <img src="/assets/img/download-mobile.png" alt="Not found" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="download-banner img-res-md">
                        <img src="/assets/img/download-app.png" alt="Not found" />
                    </div>
                </section>

                <section className="herlev-pale-section sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading">
                            <span className="herlev-eyebrow">Noget for enhver frokost</span>
                            <h2>Det, Som Gør os til det Naturlige Valg</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0s">
                                    <span className="herlev-menu-icon"><i className="fas fa-utensils" /></span>
                                    <div><h3>Vi Forstår Gladsaxe-Hverdagen</h3><p>Grundskoler, private skoler og friskoler i Ballerup kan få leveret fuldt pl</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.08s">
                                    <span className="herlev-menu-icon"><i className="fas fa-bread-slice" /></span>
                                    <div><h3>Levering, Du Kan Stole På</h3><p>Når maden skal være på plads, skal den være der. Ingen undskyldninger, ingen forsinkelser. Vi har etableret rutiner og leveringslogistik specifikt til Gladsaxe, så du ved præcis, hvornår maden ankommer.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.16s">
                                    <span className="herlev-menu-icon"><i className="fas fa-box" /></span>
                                    <div><h3>Kvalitet Uden Kompromis</h3><p>Vi bruger ingredienser fra pålidelige kilder. Maden tilberedes af folk, der tager deres arbejde alvorligt. Det smager, og det mærkes – både på elever, medarbejdere og institutionens brugere.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.24s">
                                    <span className="herlev-menu-icon"><i className="fas fa-leaf" /></span>
                                    <div><h3>Fleksibilitet, Som Møder Virkeligheden</h3><p>Ikke alle dage skal være præcis ens. Nogle uger skal skoler måske have mindre mad pga. aktiviteter. Virksomheder kan få ændret antallet af portioner. Vi siger ja til rimelige ønsker, fordi vi forstår, at fleksibilitet handler om tro.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.32s">
                                    <span className="herlev-menu-icon"><i className="fas fa-glass-whiskey" /></span>
                                    <div><h3>Enkel Teknologi, Ingen Bureaukrati</h3><p>Vores onlineplatform er simpel at bruge. Du logger ind, ser dine menuer, justerer antal portioner og betaler. Ikke mere komplekst end nødvendigt.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.4s">
                                    <span className="herlev-menu-icon"><i className="fas fa-seedling" /></span>
                                    <div><h3>Ernæring for Alle Aldersgrupper</h3><p>Om det er børn, der skal få et godt frokost, medarbejdere, der skal kunne opsnappe energi, eller ældre, der skal få ernæring – vi tilpasser maden til brugergruppen.</p></div>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-audience sec-pd">
                    <div className="container">
                        <div className="row align-items-end mb-4">
                            <div className="col-lg-8">
                                <span className="herlev-eyebrow">En løsning til hverdagen</span>
                                <h2>Vores Tilbud – Fra Skoler til Virksomheder og Alt Derimellem</h2>
                                <p className="herlev-heading-note">Vi udbyder forskellige typer madordninger, så institutioner og virksomheder i Gladsaxe kan vælge præcis det, de har brug for.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>01</span>
                                    <h3>Skolemad til Grundskoler og Ungdomsuddannelser</h3>
                                    <p>Skoler i Gladsaxe kan få daglig skolemad leveret uden selv at skulle administrere menuer, bestillinger og leverancer. Vi tilbyder:</p>
                                    <ul className="herlev-check-list">
                                        <li>Varierede menuer, som ændrer sig henover året</li>
                                        <li>Tilpasning til årgang og antal elever</li>
                                        <li>Mulighed for diætiske tilpasninger og allergihåndtering</li>
                                        <li>Præcis levering til skolens tider</li>
                                        <li>Enkel bestilling via vores system</li>
                                    </ul>
                                    <Link to="/contact">Læs mere om vores skolemadordninger <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>02</span>
                                    <h3>Frokostordninger til Kontorer og Virksomheder</h3>
                                    <p>Virksomheder med ansatte i Gladsaxe kan tilbyde deres medarbejdere daglig frokost som del af arbejdsmiljøet. Det bidrager til:</p>
                                    <ul className="herlev-check-list">
                                        <li>Højere medarbejdertilfredshed</li>
                                        <li>Bedre arbejdsmiljø</li>
                                        <li>Mindre stress blandt personalet</li>
                                        <li>Ingen administrative byrder for virksomheden selv</li>
                                    </ul>
                                    <p>Vi håndterer menuer, tilberedning og levering. Du administrerer blot, hvem der deltager.</p>
                                    <Link to="/contact">Udforsk frokostordninger til virksomheder<i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>03</span>
                                    <h3>Kantineordninger for Institutioner</h3>
                                    <p>Institutioner – daginstitutioner, plejecentre, ungdomsklubber, arbejdssociale tilbud – kan få deres kantine- og forplejningsopgave håndteret af os. Vi sikrer:</p>
                                    <ul className="herlev-check-list">
                                        <li>Ernæringsmæssigt passende måltider</li>
                                        <li>Variation, der passer til brugergruppen</li>
                                        <li>Fleksibilitet i forhold til antal dage og specialønsker</li>
                                        <li>Reduceret administrative belastning</li>
                                    </ul>
                                    <Link to="/contact">Se hvordan institutioner profiterer <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>04</span>
                                    <h3>Catering til Møder, Events og Særlige Anledninger</h3>
                                    <p>Når Gladsaxe-virksomheder, skoler eller organisationer arrangementer – møder, fester, seminarer eller sociale arrangementer – kan vi levere catering tilpasset netop denne begivenhed.</p>
                                    <ul className="herlev-check-list">
                                        <li>Skræddersyede menuer</li>
                                        <li>Fleksibel portioneringsstørrelse</li>
                                        <li>Levering til dit arrangement</li>
                                        <li>Professionel præsentation</li>
                                    </ul>
                                    <Link to="/contact">vide mere <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>05</span>
                                    <h3>Mad til Særlige Øjeblikke</h3>
                                    <p> Ud over faste ordninger kan du også bestille mad til engangstilfælde – en virksomhedsfest, en klassefest, eller et møde, der skal serveres ordentligt.</p>
                                    <Link to="/contact">vide mere <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-steps sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="herlev-copy-block">
                                    <h2>Fra Første Samtale til Fast Madordning – Her er Processen</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <Link className="btn btn-1" to="/signup">Opret bruger</Link>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="herlev-step-list">
                                    <div className="herlev-step">
                                        <span>01</span>
                                        <div>
                                            <h3>Du Tager Kontakt</h3>
                                            <p>Ring til os eller send en henvendelse. Beskriv hvad du har brug for: Hvor mange personer? Hvilken type mad? Hvilke ønsker eller begrænsninger?</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>02</span>
                                        <div>
                                            <h3>Vi Analyserer og Foreslår</h3>
                                            <p>Vi gennemgår dine behov og laver et konkret forslag til en ordning, der passer. Vi diskuterer menuer, pris og praktiske detaljer.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>03</span>
                                        <div>
                                            <h3>Du Træffer Beslutning</h3>
                                            <p>Når du har hørt alt, du skal høre, godkender du ordningen eller foreslår justeringer.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>04</span>
                                        <div>
                                            <h3>Vi Starter LeveringenVi Sætter Operationen i Gang</h3>
                                            <p>Fra aftalt startdato begynder vi at levere. Du får adgang til vores bestillingssystem og kan justere dine behov løbende.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>05</span>
                                        <div>
                                            <h3>Løbende Tilpasning og Support</h3>
                                            <p>Hvis behov ændrer sig, kan du kontakte os. Hvis der er spørgsmål eller ønsker, er vi der.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p>Det er så simpelt – og så omfattende, som du har brug for det.</p>
                        </div>
                    </div>
                </section>

                <section className="herlev-reasons sec-pd">
                    <div className="container">
                        <div className="herlev-reasons-heading">
                            <div>
                                <span className="herlev-eyebrow">Det Gør os til dit Naturlige Valg i Ballerup</span>
                                <h2>Hvordan Vi Konkret Støtter Gladsaxe-Skoler, -Virksomheder og -Institutioner</h2>
                            </div>
                        </div>
                        <div className="herlev-reasons-grid">
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">01</div>
                                <div className="herlev-reason-icon"><i className="fas fa-school" /></div>
                                <div>
                                    <h3>Skoler Får Professionaliseret Skolemad</h3>
                                    <p>Grundskoler, privatskole, friskoler og ungdomsuddannelser i Gladsaxe kan afsted med pålidelig daglig skolemad. Vi tilpasser os skolens timeplan – hvornår skal maden være der? Vi tilpasser os elevantallet – hvor mange portioner pr. dag? Vi tilpasser os ønsker – skal det være varmt eller koldt? Skolekøkkenet kan selv beslutte, om de vil tilberede maden videre eller blot serveringen som den kommer.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">02</div>
                                <div className="herlev-reason-icon"><i className="fas fa-utensils" /></div>
                                <div>
                                    <h3>Virksomheder Tilbyder Deres Medarbejdere Mere</h3>
                                    <p>Kontorer og arbejdspladser i Gladsaxe kan være foran konkurrenterne ved at tilbyde frokost. Det tager ikke tid – vi håndterer hele operationen. Det koster ikke dyrt – vi tilbyder konkurrencedygtige priser. Og det betydet noget for medarbejderne, som værdsætter en arbejdsgiver, der tager sig af dem.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">03</div>
                                <div className="herlev-reason-icon"><i className="fas fa-mobile-alt" /></div>
                                <div>
                                    <h3>Institutioner Simplificerer Deres Drift</h3>
                                    <p>Børnehaver, daginstitutioner, ældrecentre og andre tilbud kan få deres forplejningsopgave løst uden selv at skulle administrere køkkenet eller tilberedningen. Mere tid til kerneopgaven – at passe brugerne.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">04</div>
                                <div className="herlev-reason-icon"><i className="fas fa-leaf" /></div>
                                <div>
                                    <h3>Organisationer og Foreninger Får Hjælp</h3>
                                    <p>Foreninger, klubber, og andet frivilligt arbejde i Gladsaxe – hvis I skal organisere mad til medlemmer eller arrangemente, kan vi være med.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">05</div>
                                <div className="herlev-reason-icon"><i className="fas fa-map-marker-alt" /></div>
                                <div>
                                    <h3>Sådan Kommer Du Igang</h3>
                                    <p>Du findes overalt i Gladsaxe – nord for København, tæt på motorvejen, blandt villaer, lejligheder og blandede bebyggelser. Uanset hvor du er, kan vi levere. Ring eller skriv – første skridt er altid en chat om, hvad du har brug for.</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>

                <section className="sec-pd rel-z-1">
                    <div className="top-bottom-shaps">
                        <span className="shap shap-1" />
                        <span className="shap shap-2" />
                    </div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 mmb-20">
                                <div className="img-style-1 wow fadeInLeft">
                                    <img src="/assets/img/about-1.png" alt="Not found" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <div
                                        className="title-1 wow fadeInRight"
                                        data-wow-delay="0.1s"
                                        style={{
                                            visibility: "visible",
                                            animationDelay: "0.1s",
                                            animationName: "fadeInUp",
                                        }}
                                    >
                                        <h1>Hvem kan bruge Onlineskolemad i Ballerup?</h1>
                                        <div className="herlev-rule"><span /><span /></div>
                                        <p>
                                        </p>
                                        <div className="mt-3">
                                            <p>
                                                Løsningen er først og fremmest relevant for skoler og skolefamilier, men virksomhedens cateringaktiviteter gør også tilbuddet relevant i andre sammenhænge.
                                            </p>
                                            <p>Det kan eksempelvis være:</p>
                                            <ol>
                                                <li><strong>Skoler</strong>, der ønsker en praktisk løsning til skolemad.</li>
                                                <li><strong>Forældre</strong>, der vil bestille frokost til deres børn.</li>
                                                <li><strong>Institutioner</strong>, hvor der er behov for mad til flere børn eller deltagere.</li>
                                                <li><strong>Virksomheder</strong>, der ønsker mad eller forplejning til medarbejdere eller arrangementer.</li>
                                                <li><strong>Organisationer</strong>, der har brug for mad til et møde eller arrangement.</li>
                                                <li><strong>Arrangører</strong>, der ønsker catering til en aktivitet i Ballerup.</li>
                                            </ol>
                                            <p>Den konkrete løsning afhænger af behov, antal personer og den aftale, der kan etableres.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-faq sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading"><span className="herlev-eyebrow">Spørgsmål og svar</span><h2>Spørgsmål og Svar om Madordninger i Gladsaxe</h2></div>
                        <div className="herlev-faq-list">
                            <details open>
                                <summary>Kan vi få skolemad til vores skole i Gladsaxe?<i className="fas fa-plus" /></summary>
                                <p>Ja. Vi leverer til alle typer uddannelsesinstitutioner i Gladsaxe – uanset størrelse, tilskrivningsform eller aldersgruppe. Kontakt os med dine konkrete behov, og vi laver et tilbud.</p>
                            </details>
                            <details>
                                <summary>Hvordan fungerer bestilling af frokost til vores kontor?<i className="fas fa-plus" /></summary>
                                <p>Du meddeler os antallet af medarbejdere, som skal have frokost. Vi aftaler menuer og leveringsdage. Du kan justere antallet med kort varsel, hvis folk er syge eller væk. Fakturering sker enkelt og gennemsigtigt.</p>
                            </details>
                            <details>
                                <summary>Hvad hvis nogle medarbejdere har allergier eller ønsker vegetarisk mad?<i className="fas fa-plus" /></summary>
                                <p>Vi tilbyder altid flere menuvarianter, inklusiv vegetariske retter. Allergier og diætiske ønsker noteres, og maden tilberedes derefter. Du fortæller os om dine medarbejderes behov, og vi sikrer, at alle får noget, de kan spise.</p>
                            </details>
                            <details>
                                <summary>Hvor hurtigt kan vi starte med en madordning?<i className="fas fa-plus" /></summary>
                                <p>Det afhænger af, hvad du har brug for. Har du brug for at starte på kort varsel, forsøger vi at finde en løsning. Kontakt os og beskriv tidsperspektivet.</p>
                            </details>
                            <details>
                                <summary>Kan institutioner i Gladsaxe få madordning?<i className="fas fa-plus" /></summary>
                                <p>Ja, institutioner – børnehaver, plejecentre, ungdomsklubber osv. – kan få fast madordning. Vi tilpasser maden til brugergruppen og er fleksible omkring antal og frekvens.</p>
                            </details>
                            <details>
                                <summary>Tilbyder I catering til virksomhedsamrangementer?<i className="fas fa-plus" /></summary>
                                <p>Ja. Hvis din virksomhed i Gladsaxe skal holde møde, fest eller event, kan vi levere catering. Vi arbejder med dig omkring menuer og antal personer.</p>
                            </details>
                            <details>
                                <summary>Hvad hvis vi har små børn med særlige behov?<i className="fas fa-plus" /></summary>
                                <p>Børnehaver og daginstitutioner kan få menuer tilpasset små børns ernæringsbehov. Hvis der er allergier, madoversættelser eller anden tilpasning, noterer vi dette og sikrer, at maden passes til barnet.</p>
                            </details>
                            <details>
                                <summary>Hvor leverer I i Gladsaxe, og hvad er leveringsmuligheder?<i className="fas fa-plus" /></summary>
                                <p>Vi leverer til hele Gladsaxe Kommune. Levering til skoler, kontorer og institutioner sker efter aftale. Hvordan og hvornår – det aftaler vi med dig på baggrund af dine behov.</p>
                            </details>
                            <details>
                                <summary>Hvor meget koster det?<i className="fas fa-plus" /></summary>
                                <p>Priserne afhænger af, hvad du ønsker – antal personer, type mad, hyppighed osv. Vi giver konkrete prisforslag efter at have forstået dine behov. Der er ingen skjulte omkostninger.</p>
                            </details>
                        </div>
                    </div>
                </section>

                <section className="herlev-cta">
                    <div className="container">
                        <div className="herlev-cta-inner"><div>
                            <span className="herlev-eyebrow">Lokalt forankret i Gladsaxe</span>
                            <h2>Lad os Tage Forplejningen – Du Tager Rest</h2>
                            <p>I Gladsaxe har du nok at tænke på. Arbejde, familie, daglige gøremål. En madordning, der virker, er ikke blot praktisk – det er frihed.</p>
                            <p>Onlineskolemad gør forplejningen til en ikke-sag. Enten du driver en skole, arbejder i HR på en virksomhed, leder en institution eller organiserer en forening – vi har en løsning.</p>
                            <br />
                            <p>
                                Første skridt er enkelt:
                                <ul style={{ color: '#ffff' }}>
                                    <li style={{ color: '#ffff' }}><strong>Kontakt os</strong> – fortæl hvad du har brug for</li>
                                    <li style={{ color: '#ffff' }}><strong>Vi laver et tilbud</strong> – specifikt for dig</li>
                                    <li style={{ color: '#ffff' }}><strong>Du siger ja</strong> – og vi begynder</li>
                                    <li style={{ color: '#ffff' }}><strong>Du nyder godt af det</strong> – hver dag</li>
                                </ul>
                            </p>
                            <p>Du får pålidelig forplejning, administrativ lettelse og kvalitet, du kan stole på.</p>
                        </div>
                            <div className="herlev-cta-actions">
                                <Link className="btn btn-1" to="/contact">Kontakt Onlineskolemad</Link>
                                <a href="tel:26227469">Telefon: 26 22 74 69</a>
                                <a href="/">Adresse: Herlev Bygade 27, 2730 Herlev</a>
                                <a href="/">E-mail: onlineskolemad@hotmail.com</a>
                            </div>
                        </div>
                    </div>
                </section>
            </main >
        </>
    )
}

export default GladsaxeSkolemad